module.exports = __webpack_public_path__ + "static/gulp-e8839de1198baa755379ff68424b0fce.png";